import React from 'react';

const ManagementPolicyPageMain = (props) => {

  return (
    <div id="content1200">
      <div className="companyTitle">
        <span className="nielsen-navyBlack">버즈워드 수집 프로그램의 검색결과 수집에 대한 닐슨미디어코리아의 정책</span>
      </div>
      <div className="txt_box">
        <div className="privacy_titbox">1. 검색결과의 수집방침</div>
				버즈워드 게시글 검색은 버즈워드 수집 프로그램이 특정 웹사이트를 방문하여 수집하거나 개발자 플랫폼 API(Application Program Interface)를 통해 수집한 국내의 게시글을 대상으로 합니다. 버즈워드 서비스는 인터넷 상에 소중한 정보들을 게시▫제공한 웹 운영자와 저작자들의 의견을 존중하며 게시글 수집 운영에 대한 표준 기준을 준수하기 위해 최선을 다하고 있습니다.
        <div className="privacy_titbox">2. 버즈워드 내 게시글에 대한 보호방침</div>
        버즈워드는 대시보드 서비스를 통해 구축되는 데이터 베이스에 대하여 소정의 저작권 보호 장치로써 이를 보호하고 있습니다. 이를 위해 아래와 같은 내부 방침에 따라 서비스를 운영하고 있음을 알려드립니다.<br /><br />
        1) 일반인이 접근 가능한 HTML 정보만을 수집하며, 웹사이트 내 노출된 개인정보는 수집하지 않습니다.<br /><br />
        2) 버즈워드 대시보드 서비스에서 이용하는 게시글이 저작자의 의사에 반하여 다른 서비스에서 이용되지 않도록 노력하고 있습니다.<br />
        이에 따라 검색 결과는 공개된 게시글의 제목, 링크, 작성일만 제공하고 있으며, 작성자명은 제공하지 않습니다.<br /><br />
        3) 버즈워드 대시보드 서비스는 비공개로 작성된 게시글은 수집하지 않습니다.
        <div className="privacy_titbox">3. 본인의 게시글을 검색결과에서 제외하고자 하는 경우</div>
        1) 버즈워드 게시글 검색이 해당 변경 상태를 재확인하는데 다소 시간이 걸릴 수 있기 때문에 버즈워드 게시글 검색 결과에서 해당 결과가 즉시 제거되지 않을 수 있습니다.<br /> 즉시 삭제가 되어야 하거나 부득이한 상황이 있는 경우, 게시글 삭제 처리 방법을 통해 문의 주시기 바랍니다.<br /><br />
        2) 게시글에 대한 기술적인 접근은 홈페이지의 루트 디렉토리에 국제적 로봇 배제 장치인 robots.txt 설정을 확인하시기 바랍니다.<br />
        robots.txt에 대한 자세한 설명은 robotstxt.org 에서 참고할 수 있으며, robots.txt을 적용하는데 다소 시간이 걸릴 수 있습니다.<br /><br />
        3) 국제적 로봇 배제 장치가 되어 있다 하더라도, 서비스를 운영하는 플랫폼사의 이용약관에서 게시글 공개를 원칙으로 하면서 플랫폼사에서 제공하는 개발자 API를 통해 인증과정을 거친 경우 데이터 수집은 지속될 수 있으므로, 검색결과에서 제외를 원하는 경우 게시글 삭제 처리 방법을 통해 문의 주시기 바랍니다.         
      </div>   
    </div>
  )
}

export default ManagementPolicyPageMain;